import {Controller} from "@hotwired/stimulus"
import Choices from "choices.js";

// Connects to data-controller="choices"
export default class extends Controller {
    static values = { enableSort: {type: Boolean, default: false}, prompt: { type: String, default: "" } }

    initialize() {
        this._beforeCache = () => {
            this._caching = true;
            this._destroyChoices();
        };
    }

    connect() {
        this._connected = true;
        document.addEventListener("turbo:before-cache", this._beforeCache);
        // Choices moves the select into its wrapper, triggering a Stimulus
        // disconnect/reconnect. Keep the existing instance during that move.
        if (this.choices || this._caching) return;

        this.choices = new Choices(this.element, {
            searchEnabled: false,
            itemSelectText: this.promptValue,
            shouldSort: this.enableSortValue
        });
    }

    disconnect() {
        this._connected = false;
        document.removeEventListener("turbo:before-cache", this._beforeCache);
        // Wait for any reconnect caused by wrapping/unwrapping the select.
        queueMicrotask(() => {
            if (this._connected) return;
            this._destroyChoices();
            this._caching = false;
        });
    }

    _destroyChoices() {
        // Leave a native select (with its current value) in Turbo snapshots.
        this.choices?.destroy();
        this.choices = null;
    }
}
